import React, { useEffect, useState } from 'react';

interface ElegantBackgroundProps {
  className?: string;
}

const ElegantBackground: React.FC<ElegantBackgroundProps> = ({ className }) => {
  const [mounted, setMounted] = useState(false);
  
  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className || ''}`}>
      <svg 
        className="absolute inset-0 w-full h-full" 
        preserveAspectRatio="xMidYMid slice"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
      >
        <defs>
          <linearGradient id="backgroundGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#fafafa" />
            <stop offset="100%" stopColor="#f7f7f9" />
          </linearGradient>
          
          <linearGradient id="accentGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#1A1F71" stopOpacity="0.03" />
            <stop offset="100%" stopColor="#1A1F71" stopOpacity="0.01" />
          </linearGradient>
          
          <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="30" result="blur" />
            <feComposite in="SourceGraphic" in2="blur" operator="over" />
          </filter>
          
          <pattern id="dots" width="40" height="40" patternUnits="userSpaceOnUse">
            <circle cx="2" cy="2" r="1" fill="#1A1F71" fillOpacity="0.07" />
          </pattern>
        </defs>
        
        {/* Base background */}
        <rect width="100%" height="100%" fill="url(#backgroundGradient)" />
        
        {/* Dot pattern overlay */}
        <rect width="100%" height="100%" fill="url(#dots)" opacity="0.3" />
        
        {/* Large decorative shapes */}
        <circle 
          cx="0%" 
          cy="15%" 
          r="400" 
          fill="url(#accentGradient)" 
          className={`transition-opacity duration-1000 ease-out ${mounted ? 'opacity-100' : 'opacity-0'}`}
          style={{ transitionDelay: '200ms' }}
        />
        
        <circle 
          cx="100%" 
          cy="85%" 
          r="500" 
          fill="url(#accentGradient)" 
          className={`transition-opacity duration-1000 ease-out ${mounted ? 'opacity-100' : 'opacity-0'}`}
          style={{ transitionDelay: '400ms' }}
        />
        
        {/* Elegant curved lines */}
        <path 
          d="M-100,300 C400,100 800,550 1600,300" 
          stroke="#1A1F71" 
          strokeOpacity="0.04"
          strokeWidth="2"
          fill="none"
          className={`transition-opacity duration-1000 ease-out ${mounted ? 'opacity-100' : 'opacity-0'}`}
          style={{ transitionDelay: '600ms' }}
        />
        
        <path 
          d="M-100,600 C600,800 1200,400 1900,700" 
          stroke="#1A1F71" 
          strokeOpacity="0.03"
          strokeWidth="3"
          fill="none"
          className={`transition-opacity duration-1000 ease-out ${mounted ? 'opacity-100' : 'opacity-0'}`}
          style={{ transitionDelay: '800ms' }}
        />
        
        {/* Subtle accent shapes */}
        <g className={`transition-opacity duration-1000 ease-out ${mounted ? 'opacity-100' : 'opacity-0'}`} 
           style={{ transitionDelay: '1000ms' }}>
          {Array.from({ length: 5 }).map((_, i) => (
            <circle 
              key={`accent-${i}`}
              cx={`${20 + (i * 15)}%`}
              cy={`${30 + (i * 10)}%`}
              r={10 + (i * 5)}
              fill="#1A1F71"
              fillOpacity={0.02 - (i * 0.003)}
            />
          ))}
        </g>
        
        {/* Glowing accent */}
        <circle 
          cx="85%" 
          cy="15%" 
          r="120" 
          fill="#1A1F71" 
          fillOpacity="0.04" 
          filter="url(#glow)"
          className={`transition-opacity duration-1000 ease-out ${mounted ? 'opacity-100' : 'opacity-0'}`}
          style={{ transitionDelay: '1200ms' }}
        />
      </svg>
    </div>
  );
};

export default ElegantBackground; 